import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Input, FormGroup, Label, Row, Col } from 'reactstrap';
import ErrorBoundary from '../../../ErrorBoundary';
import { NumericFormat } from 'react-number-format';

const InputNumberCellRender = ({

    rowData,
    columnName,
    updateRowValue,
    required = false,
    hasTouched = false,
    disabled = false,
    editPhoneNumber, wacErr,
    wacErrZero
}) => {
    const subProps = {};
    const value = rowData[columnName] || editPhoneNumber == false ? rowData[columnName] : 0;
    const [text, setText] = useState(value);

    const handlerChange = (event) => {
        let { value } = event.target;
        
        if (value.startsWith('-')) {
            value = value.slice(1); 
        }
    
        setText(value); 
        updateRowValue(value, columnName, rowData);
    };

    const touced = required && hasTouched;

    if (touced) {
        subProps.title = 'Reason is required';
    }

    return (
      <div>
        <ErrorBoundary>
          <FormGroup>
            <NumericFormat
              type="text"
              disabled={disabled}
              name={columnName}
              id={columnName}
              decimalScale={2}
              value={text}
              maxlength={columnName == 'bupp' ? "15" : editPhoneNumber == false ? "10" : ""}
              style={{ marginTop: editPhoneNumber == false ? 14 : "" ,marginTop:"0px"}}
              onChange={handlerChange}
              autoComplete="off"
              className={
                editPhoneNumber == false
                  ? "form-control extra-class"
                  : `${required ? "required form-control" : ""}`
              }
              {...subProps}
            />
            {wacErr && (text === "" || text <= 0) && (
              <div className="text-danger">
                {(text === "")
                  ? `${columnName == "bupp" ? "BUPP" : columnName} is a required field`
                  : (text <= 0)
                  ? `${columnName == "bupp" ? "BUPP" : columnName} should be greater than 0`
                  : null}
              </div>
            )}
          </FormGroup>
        </ErrorBoundary>
      </div>
    );
};

export default InputNumberCellRender;
